import { Box, Typography } from '@mui/material';
import React from 'react';
import {
	// createSearchParams,
	// useSearchParams,
	useNavigate,
} from 'react-router-dom';
import SearchBox from '../components/AppBar/SearchBox';

export default function Search() {
	const navigate = useNavigate();
	return (
		<div>
			<div
				style={{
					position: 'absolute',
					top: '0px',
					height: '100vh',
					width: '100vw',
					backgroundColor: 'rgb(222,226,230)',
					background:
						'linear-gradient(180deg, rgba(222,226,230,1) 35%, rgba(0,146,180,1) 100%)',
				}}
			>
				<Box
					sx={{
						boxShadow: 'none',
						p: '2px 4px',
						display: 'flex',
						alignItems: 'center',
						// width: {
						// 	xs: '100%',
						// 	sm: '500px',
						// },
						margin: 'auto',
						mt: '250px',
						pl: { sm: '50px' },

						flexDirection: 'column',
					}}
				>
					<Box sx={{ mb: '20px' }}>
						<Typography variant="h3" color="initial">
							Reale
						</Typography>
					</Box>
					<Box>
						<SearchBox
							onChange={(e: any, value: any) => {
								console.log(value); // the value contains the pointInfo Object
								navigate(
									`/main/?searchQuery=${JSON.stringify([
										Math.random(),
										Math.random(),
									])}`
								);
							}}
							sx={{
								boxShadow: 'none',
								p: '2px 4px',
								display: 'flex',
								alignItems: 'center',
								width: {
									xs: '200px',
									sm: '500px',
								},
								// margin: 'auto',
								// mt: '300px',
								// pl: '50px',

								transition: 'width 0.4s ease 0s',
							}}
						/>
					</Box>
				</Box>
			</div>
		</div>
	);
}
